/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'gemini/lib/@waca/dashboard-common/dist/core/Collection',
	'./TimelineEpisodeEntry'
], function(Collection, TimelineEpisodeEntry) {
	var TimelineEpisodes;
	TimelineEpisodes = Collection.extend({

		modelClass: TimelineEpisodeEntry,

		init: function() {
			TimelineEpisodes.inherited('init', this, arguments);
		}
	});
	return TimelineEpisodes;
});
